jQuery($ => {
    class CurrentQuoteIndicator {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._count   = this._element.find('.m-current-quote-indicator__count');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        $(document).ajaxComplete((event, xhr, settings) => {
          if (!settings.url || !settings.url.includes('wc-ajax')) return;
          this.update_quote_count();
        });
      }

      update_quote_count() {
        if (this._element.length && this._count.length) {
          $.ajax({
            type: 'GET',
            url: AJAX.url,
            data: {
              'action': 'get_quote_items_count',
            },
            beforeSend: () => {
              
            },
            success: (result) => {
              if (result?.data) {
                this._count.text(result.data.count);

                this._element.addClass('m-current-quote-indicator--has-items');
                this._element.addClass('m-current-quote-indicator--animate');
                setTimeout(() => {
                  this._element.removeClass('m-current-quote-indicator--animate');
                }, 1100);
              }
            },
            error: function(error) {
              console.error(error);
            },
            complete: () => {
              
            }
          })
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.current_quote_indicator = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].current_quote_indicator = new CurrentQuoteIndicator(_[i], opt);
        else
          ret = _[i].current_quote_indicator[opt].apply(_[i].current_quote_indicator, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-current-quote-indicator').current_quote_indicator();
});